export enum PayerContractualDiscount {
    Contract = 1,
    Class = 2,
    Payer = 3
}